export default __webpack_public_path__ + "static/media/lysningen-property-07.aa0c19ef.jpg";